<mat-checkbox [formField]="certificateForm.certificateAllowed" class="full-width">
  {{ 'certificate.allowed' | translate }}
</mat-checkbox>
@if (certificateModel().certificateAllowed) {
  <mat-form-field class="full-width">
    <mat-label>{{ 'certificate.template' | translate }}</mat-label>
    <mat-select [formField]="certificateForm.certificateTemplateId">
      @for (template of certificateTemplates(); track template.id) {
        <mat-option [value]="template.id">{{ template.name }}</mat-option>
      }
    </mat-select>
    <mat-error>{{ 'event.is_required_field' | translate }}</mat-error>
  </mat-form-field>
}
